import React from 'react';
export default class SwitchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status : this.props.transporter.is_active
    }
  }
  handleInputChange = (e) =>{   
      this.props.handleChangeActive(this.props.groupId,this.props.transporter.id, e.target.checked);
  }
  componentWillReceiveProps(nextProps){
    this.setState({
      status : nextProps.isActive
    })
  }
  render() {   
   //console.log(this.props) ;
    return (
      <div className="switch" >
          <input type="checkbox" disabled={this.props.isActive} checked={this.state.status} id={this.props.transporter.id + this.props.groupId}  value={this.props.groupId} onChange = {this.handleInputChange}/>
          <label htmlFor={this.props.transporter.id + this.props.groupId}></label>
      </div>
    )
  }
}
